import React__default, { useContext } from 'react';
import { L as LocalizationContext } from '../../chunks/bundle-d1cOX5nv.js';
import MessageInput from '../../ui/MessageInput.js';
import { u as useOpenChannelContext } from '../../chunks/bundle-c6Xd_0m8.js';
import '../../chunks/bundle-CxLxJCBu.js';
import '../../chunks/bundle-DS1EhNtb.js';
import '../../chunks/bundle-D2GzZ_yy.js';
import '../../chunks/bundle-CpMvhj21.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-CjJk57u5.js';
import '../../chunks/bundle-GawAxqNK.js';
import 'dompurify';
import '../../chunks/bundle-B5pWUwTI.js';
import '../../chunks/bundle-CiR8AZTC.js';
import '../../chunks/bundle-Bs4dlPq1.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-kFa80LJe.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-DiK8ifY3.js';
import '../../chunks/bundle-C-nZYnmy.js';
import '../../chunks/bundle-DP3z2QNm.js';
import '../../chunks/bundle-AmtSwuex.js';
import '../../chunks/bundle-DXFVroy5.js';
import '@sendbird/uikit-tools';
import '../../chunks/bundle-DRpjMk0B.js';
import 'react-dom';
import '../../chunks/bundle-Ci-RNuvu.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../../chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle-DdJ9pMWn.js';
import '../../chunks/bundle-BzR1dD25.js';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-DXKWyDSR.js';
import '../../chunks/bundle-mqagBpi9.js';
import '../../chunks/bundle-B5N-CojP.js';
import '../../chunks/bundle-C_zEpfCP.js';

var OpenChannelInput = React__default.forwardRef(function (props, ref) {
    var _a = useOpenChannelContext(), currentOpenChannel = _a.currentOpenChannel, disabled = _a.disabled, handleSendMessage = _a.handleSendMessage, handleFileUpload = _a.handleFileUpload, amIMuted = _a.amIMuted;
    var channel = currentOpenChannel;
    var stringSet = useContext(LocalizationContext).stringSet;
    var value = props.value;
    function getPlaceHolderString() {
        if (amIMuted) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED;
        }
        if (disabled) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
        }
        return '';
    }
    if (!channel) {
        return null;
    }
    return (React__default.createElement("div", { className: "sendbird-openchannel-footer" },
        React__default.createElement(MessageInput, { channel: currentOpenChannel, ref: ref, value: value, disabled: disabled, isVoiceMessageEnabled: false, onSendMessage: handleSendMessage, onFileUpload: handleFileUpload, placeholder: getPlaceHolderString() })));
});

export { OpenChannelInput as default };
//# sourceMappingURL=OpenChannelInput.js.map
